export const isVue = (_: Vue | Element): _ is Vue => Boolean((_ as Vue).$el);

export const isNullish = <T>(_: T | undefined | null): _ is undefined | null => (_ === null || _ === undefined);
export const isNotNullish = <T>(_: T | undefined | null): _ is T => !isNullish(_);

export type OptionalExceptFor<T, TRequired extends keyof T = keyof T> = Partial<
	Pick<T, Exclude<keyof T, TRequired>>
> &
	Required<Pick<T, TRequired>>;

export type Nullable<T> = {
	[P in keyof T]: T[P] | null | undefined;
};
